<!-- eslint-disable -->
<template>


  <!--begin::Advance Table Widget 5-->
  <div class="card card-custom gutter-b">
    <!--begin::Header-->
    <div class="card-header border-0 py-5">
      <h3 class="card-title align-items-start flex-column">
        <span class="card-label font-weight-bolder text-dark">Стол заказов</span>

      </h3>
    </div>
    <!--end::Header-->

    <!--begin::Body-->
    <div class="card-body pt-0">

      <div v-if="orders.length === 0" class="text-center mb-10">
        Заказы не найдены!
      </div>

      <div v-if="load" class="text-center mb-10">
        <b-spinner variant="primary" label="Text Centered"></b-spinner>
      </div>

      <b-form v-else>

        <!--begin::Table-->
        <div class="table-responsive">
          <table class="table table-head-custom table-vertical-center" id="kt_advance_table_widget_2">
            <thead>
            <tr class="text-uppercase">

              <th class="pl-0">#</th>
              <th style="min-width: 150px">Дата заказа</th>
              <th style="min-width: 130px; text-align: right ">Статус</th>
            </tr>
            </thead>
            <tbody>
            <template v-for="(order, i) in orders">
              <tr v-bind:key="i">

                <td class="pl-0">
                  <router-link :to="{ name: 'OrderTable', params: {id: order.id}}"
                               class="text-primary font-size-lg"
                               :class="{'font-weight-bolder' : order.new}"
                  >
                    {{order.id}}
                  </router-link>
                </td>
                <td>
                  <span class="text-dark-75 d-block font-size-lg">
                    <router-link :to="{ name: 'OrderTable', params: {id: order.id}}"
                                 class=" text-primary font-size-lg"
                                 :class="{'font-weight-bolder' : order.new}"
                    >
                      {{ moment(order.created_at).format('lll') }}
                    </router-link>
                  </span>
                </td>

                <td class="pr-0 text-right">

                  <span v-if="order.new" class="text-dark-75 d-block font-size-lg font-weight-bolder">
                    Новый
                  </span>

                  <span v-else class="text-dark-75 d-block font-size-lg font-weight-bolder">
                    Прочитан
                  </span>

                </td>

              </tr>
            </template>
            </tbody>
          </table>
        </div>


        <Paginate :route_link="'OrderTables'" :filter="filter" />
      </b-form>
      <!--end::Table-->


    </div>
    <!--end::Body-->


  </div>
  <!--end::Advance Table Widget 5-->

</template>

<script>
import moment from "moment";
require('moment/locale/ru');
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import {
  GET_ORDER_TABLES,
} from "../../../core/services/store/orders.module";
import {SET_ALERT} from "../../../core/services/store/alert.module";
import Paginate from "../Paginate";
export default {
  name: "orderTables",
  components: {Paginate},

  mounted(){
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Все заказы" }]);
    this.getFilter();
    this.interval()
  },

  computed: {
    ...mapGetters({
      paginate: 'paginateGetters',
      orders: 'gettersOrderTables',
      load: 'getOrderLoad',
      errors: 'errorsOrders',
    }),

  },

  data(){
    return{

      polling: null,

      moment:moment,
      filter: {
        to: '50',
      },

    }
  },

  methods:{

    async getFilter(){
      try {
        await this.$store.dispatch(GET_ORDER_TABLES, {'page': this.$route.params.page, 'filter': this.filter});
        if (this.orders.length === 0 && this.paginate.total > 0){
          this.$router.push({ name: 'Orders', params: {page: 1}})
        }
      } catch (e) {
        this.showAlert('Ошибка загрузки', 'danger', 'toast');
      }
    },


    interval(){
      const get = () => {
        if (this.$route.name === 'OrderTables'){
          this.getFilter()
        }
      }
      this.polling = setInterval(() => {
        get()
      }, 60000)
    },


    showAlert(text, variant, type) {
      this.$store.commit(SET_ALERT, {text, variant, type});
    },

  },

  beforeDestroy () {
    clearInterval(this.polling)
  },

  watch: {
    $route: function () {
      this.getFilter()
    },

    "filter.to": function() {
      this.getFilter()
    },

  }
}
</script>

<style scoped>

</style>